<template>
  <div v-click-outside="closeDropdown">
    <ul class="report-dropdown one-column pointer">
      <li
        :class="{'inactive': !showDropDown, 'active': showDropDown}"
      >
        <span
          v-if="modelValue != null"
          class="clearIconContainer"
          @click="toggleValue(null)"
        >
          <svg
            class="clearIcon"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 1.5L1 8.5"
              stroke="#666666"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1 1.5L8 8.5"
              stroke="#666666"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <div
          tabindex="0"
          class="pointer h6"
          @click.self="showDropDown = !showDropDown"
        >
          <template
            v-if="modelValue != null"
          >
            <label>{{ label }}:</label>
            <button
              aria-label="display dropdown"
              @click="displayDropDown()"
            >
              {{ options[modelValue] }}
            </button>
          </template>
          <template
            v-else
          >
            {{ label }}
          </template>
        </div>

        <ul
          v-show="showDropDown"
        >
          <template
            v-for="(optionLabel, value) in options"
            :key="'dropdown' + value"
          >
            <li
              :class="{'active selected': modelValue === +value}"
              aria-label="change value"
              @click="toggleValue(+value)"
            >
              <a aria-hidden="true">{{ optionLabel }} </a>
            </li>
          </template>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
/* input option as map object or a simple array

value will be integer, either be the index or the string, or the key of the option

it may need to be converted for proper API calls.

*/
import { Ref, PropType, ref } from 'vue';
const props = defineProps({
  label: { type: String, default: '' },
  modelValue: { type: Number as PropType<number|null>, default: null },
  options: { type: Object, default: () => { return {}; } }
});
const emit = defineEmits(['update:modelValue']);
const showDropDown:Ref<boolean> = ref(false);
const toggleValue = (value: number|null) => {
  emit('update:modelValue', value === props.modelValue ? null : value); // previously was `this.$emit('input', title)`
  // this.$emit('filter:modelValue', value) // previously was `this.$emit('input', title)`
  showDropDown.value = false;
};
const closeDropdown = () => {
  if (showDropDown.value) {
    showDropDown.value = false;
  }
};

const displayDropDown = () => {
  showDropDown.value = !showDropDown.value;
};

</script>
<style lang="scss" scoped>
  @import 'dropdown.scss';
  .clearIconContainer {
    position: absolute;
    right: 35px;
    top: 15px;
    z-index: 5;
  }
  button{
    cursor: pointer;
  }
  svg.clearIcon {
    margin-top: 3px;
    width: 18px;
  }
  </style>
